/**
 * Customer-facing policy lines shared by checkout trust UI and FAQ/help content.
 * Update FAQ entries to import these strings so checkout and help stay aligned.
 */

export const POLICY_DELIVERY_WINDOW_SNIPPET =
  'Yes, available delivery windows are shown at checkout based on your location and current courier capacity.';

/** Same-day live ETA, checkout / post-purchase trust (issue #45). */
export const POLICY_SAME_DAY_ETA_CONFIDENCE_SNIPPET =
  'After dispatch, the map and tracking page show a live arrival window that updates as the driver progresses. Times are estimates, traffic, weather, and batching can shift them.';

export const POLICY_MAIL_ORDER_TRANSIT_SNIPPET =
  'Most orders are packed promptly, then transit time depends on Canada Post service levels to your postal code.';

export const POLICY_SUBSTITUTION_SNIPPET =
  'Our team will offer substitutions or remove the item and adjust your order total.';

export const POLICY_CANCELLATION_SNIPPET =
  'Orders can often be canceled before dispatch. Once out-for-delivery, cancellation options may be limited.';

export const POLICY_REFUND_PROCESS_SNIPPET =
  'Approved refunds are returned to the original payment method, timing depending on your provider.';

export const POLICY_REFUND_POLICY_HREF = '/refund-policy';
export const POLICY_TERMS_HREF = '/terms-of-service';
